
const LoanTypes = () => {
  const loanTypes = [
    {
      icon: 'ri-hand-heart-line',
      title: 'Personal Loans',
      description: 'Emergency funds and unexpected expenses with flexible repayment options',
      features: ['Quick approval process', 'Competitive interest rates', 'Flexible terms'],
      color: 'bg-blue-50 text-blue-600'
    },
    {
      icon: 'ri-building-line',
      title: 'Business Start-Up Loans',
      description: 'Support for entrepreneurial members starting new ventures',
      features: ['Business plan review', 'Mentorship support', 'Growth-focused terms'],
      color: 'bg-green-50 text-green-600'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Education Loans',
      description: 'Funding for further studies and professional development',
      features: ['Direct institution payment', 'Deferred payment options', 'Career support'],
      color: 'bg-purple-50 text-purple-600'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Settlement Loans',
      description: 'Helping newcomers cover housing deposits, furniture, and transportation',
      features: ['Newcomer-friendly terms', 'Settlement guidance', 'Integration support'],
      color: 'bg-orange-50 text-orange-600'
    },
    {
      icon: 'ri-car-line',
      title: 'Vehicle Loans',
      description: 'Financing for reliable transportation needs',
      features: ['Competitive rates', 'New and used vehicles', 'Insurance guidance'],
      color: 'bg-red-50 text-red-600'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Home Improvement Loans',
      description: 'Enhance your property with renovation and improvement projects',
      features: ['Contractor partnerships', 'Project planning support', 'Flexible disbursement'],
      color: 'bg-indigo-50 text-indigo-600'
    },
    {
      icon: 'ri-coins-line',
      title: 'Microloans',
      description: 'Small-scale funding for personal projects and immediate needs',
      features: ['Simplified application', 'Quick approval', 'Minimal documentation'],
      color: 'bg-teal-50 text-teal-600'
    }
  ];

  return (
    <section id="loan-types" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Loan Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive financial solutions designed to meet the diverse needs of our community members
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {loanTypes.map((loan, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className={`w-12 h-12 ${loan.color} rounded-lg flex items-center justify-center mb-4`}>
                <i className={`${loan.icon} text-xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{loan.title}</h3>
              <p className="text-gray-600 mb-4">{loan.description}</p>
              <ul className="space-y-2">
                {loan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              <button className="mt-6 w-full bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer">
                Learn More
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LoanTypes;
